import {
    addDays,
    endOfDay,
    millisecondsToSeconds,
    startOfDay,
    subDays,
} from 'date-fns';

import { DETAILS_PARAMS_TO_REQUEST_PARAMS } from 'screens/Detail/types';

export enum DETAILS_DATA_TYPES {
    VOD = 'VOD',
    PROGRAM = 'PROGRAM',
}

export function getEpgProgramsPeriodFilter() {
    const now = new Date();

    return {
        'period.start': {
            $lte: millisecondsToSeconds(addDays(endOfDay(now), 14).getTime()),
        },
        'period.end': {
            $gte: millisecondsToSeconds(subDays(startOfDay(now), 7).getTime()),
        },
    };
}

export function getCatchupProgramsPeriodFilter() {
    const now = new Date();

    return {
        'period.start': {
            $gte: millisecondsToSeconds(subDays(now, 7).getTime()),
        },
        'period.end': {
            $lt: millisecondsToSeconds(now.getTime()),
        },
    };
}

export function getChannelIdFilter(channelId: string | undefined) {
    return channelId && channelId !== 'null'
        ? { [DETAILS_PARAMS_TO_REQUEST_PARAMS.channelId]: channelId }
        : undefined;
}
